// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import {guess} from 'zuser_agent';

export interface i_client_hints {
    browser?: {
        name: string;
        version: string;
    };
    platform?: {
        os: string;
        version: string;
        mobile: boolean;
    };
}

export const global_client_hints: {
    value: i_client_hints
} = {
    value: null,
};

export const guess_os_and_version = ()=>{
    const os = guess();
    if (global_client_hints.value && global_client_hints.value.platform)
    {
        os.version = global_client_hints.value.platform.version;
        os.os = global_client_hints.value.platform.os;
    }
    return os;
};
